import React from "react";
import PageTemplate from "../components/PageTemplate";

function Soups() {
  return (
    <PageTemplate title="Soups">
      <p>Fresh, comforting, and packed with flavor — recipes coming soon!</p>
    </PageTemplate>
  );
}

export default Soups;
